<template>
  <div class="agents-area">
    <h1 v-if="showTitle"><span class="red">פשוט</span> לפרסם רכב למכירה</h1>
    <router-view></router-view>
  </div>
</template>
<script>

import {mapGetters} from "vuex";

export default {
  name: "AgentsArea",
  data() {
    return {
      showTitle: true,
    };
  },
	computed:{
		...mapGetters(['agentAreaEnabled'])
	},
	beforeRouteUpdate(to, from, next) {
    if (to.meta && to.meta.hideTitle) {
      this.showTitle = false;
    } else {
      this.showTitle = true;
    }
    next();
  },
	methods: {
    init() {
      if (this.$route.meta && this.$route.meta.hideTitle) {
        this.showTitle = false;
      }
			if(this.agentAreaEnabled){
				this.$store.dispatch('loadCars')
			}else{
				this.$router.replace({
					name: 'home'
				})
			}
    }
  },
	mounted() {
		this.init();
	},
};
</script>
<style lang="scss">
@import "./style.scss";
@import "./swiper.scss";
</style>
